import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import "../umzug/umzug.css";
import HeroSection from "../heroSection/HeroSection";
import heroPhoto from "../../assets/images/photo.jpg";
import Footer from "../footer/Footer";
import { useTranslation } from "react-i18next";
import SEO from "../SEO";
import UmzugNavbarMenu from "../heroSection/UmzugNavbarMenu";
import { AiFillTag, AiOutlineLike, AiOutlineSafety } from "react-icons/ai";
import { FaCalculator, FaEuroSign, FaHeadphones, FaTasks, FaTruckMoving, FaUsers } from "react-icons/fa";
import { SlEarphones } from "react-icons/sl";
import { MdMoneyOff, MdOutlineAttachMoney } from "react-icons/md";
import { RiLock2Fill } from "react-icons/ri";
import { IoLocationSharp, IoTimeOutline } from "react-icons/io5";
import { CgCircleci } from "react-icons/cg";
import { LuNotebookPen, LuNotepadText } from "react-icons/lu";
import { FcGoogle } from "react-icons/fc";
import { BiSolidLike } from "react-icons/bi";
import IMG_HERO_BG from "../../assets/images/mobel-bg.jpg";
import IMG_WHY_BG from "../../assets/images/mobel-why-bg.jpg";
import { useNavigate } from "react-router-dom";
import { TbCurrencyEuroOff } from "react-icons/tb";

/* ── Unsplash image URLs – replace with local assets if preferred ── */
// const IMG_HERO_BG =
//   "https://tuggerahremovals.com.au/wp-content/uploads/Tuggerah-Removals-and-storage-carton-loading-truck.webp";

export default function MobelTransport({
  showNavbar = true,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const trustBadges = [
    { 
      icon: <FaEuroSign />, 
      label1: t("mobeltransport.trust.free.label1", "Kostenlos &"), 
      label2: t("mobeltransport.trust.free.label2", "unverbindlich") 
    },
    { 
      icon: <AiOutlineSafety />, 
      label1: t("mobeltransport.trust.secure.label1", "Geprüfte &"), 
      label2: t("mobeltransport.trust.secure.label2", "zuverlässige Partner") 
    },
    { 
      icon: <IoTimeOutline />, 
      label1: t("mobeltransport.trust.fast.label1", "Schnelle"), 
      label2: t("mobeltransport.trust.fast.label2", "Angebote") 
    },
  ]

  const whyCards = [
    {
      icon: <FaUsers />,
      title: t("mobeltransport.why.card1.title", "Viele Angebote vergleichen"),
      text: t(
        "mobeltransport.why.card1.text",
        "Erhalten Sie mehrere Angebote und wählen Sie das beste für Ihren mobeltransport."
      ),
    },
    {
      icon: <AiFillTag />,
      title: t("mobeltransport.why.card2.title", "Bis zu 30% sparen"),
      text: t(
        "mobeltransport.why.card2.text",
        "Durch den Vergleich sparen Sie Zeit und Geld bei Ihrem mobeltransport."
      ),
    },
    {
      icon: <BiSolidLike />,
      title: t("mobeltransport.why.card3.title", "Geprüfte mobelTransportsfirmen"),
      text: t(
        "mobeltransport.why.card3.text",
        "Alle Partner werden von uns geprüft und laufend bewertet."
      ),
    },
    {
      icon: <FaHeadphones />,
      title: t("mobeltransport.why.card4.title", "Persönlicher Support"),
      text: t(
        "mobeltransport.why.card4.text",
        "Unser Team hilft Ihnen bei Fragen rund um Ihren Umzug weiter."
      ),
    },
  ];

  const howSteps = [
    {
      num: "1",
      icon: <LuNotebookPen />,
      title: t("mobeltransport.how.step1.title", "MobelTransportdetails eingeben"),
      text: t(
        "mobeltransport.how.step1.text",
        "Geben Sie Abhol- und Zieladresse, MobelTransportdatum und Details an."
      ),
    },
    {
      num: "2",
      icon: <LuNotepadText />,
      title: t("mobeltransport.how.step2.title", "Angebote erhalten"),
      text: t(
        "mobeltransport.how.step2.text",
        "Erhalten Sie kostenlos mehrere Angebote von mobelTransportsfirmen in Ihrer Nähe."
      ),
    },
    {
      num: "3",
      icon: <FaTasks />,
      title: t("mobeltransport.how.step3.title", "Angebote vergleichen"),
      text: t(
        "mobeltransport.how.step3.text",
        "Vergleichen Sie Preise, Leistungen und Bewertungen der Anbieter."
      ),
    },
    {
      num: "4",
      icon: <FaTruckMoving />,
      title: t("mobeltransport.how.step4.title", "MobelTransport beauftragen"),
      text: t(
        "mobelTransport.how.step4.text",
        "Wählen Sie das passende Angebot und beauftragen Sie Ihren MobelTransport."
      ),
    },
  ];

  const trustCards = [
    {
      icon: <TbCurrencyEuroOff />,
      title: t("mobeltransport.trustBar.free.title"),
      text: t("mobeltransport.trustBar.free.text"),
    },
    {
      icon: <RiLock2Fill />,
      title: t("mobeltransport.trustBar.secure.title"),
      text: t("mobeltransport.trustBar.secure.text"),
    },
    {
      icon: <IoLocationSharp />,
      title: t("mobeltransport.trustBar.fast.title"),
      text: t("mobeltransport.trustBar.fast.text"),
    },
    {
      icon: <IoTimeOutline />,
      title: t("mobeltransport.trustBar.nationwide.title"),
      text: t("mobeltransport.trustBar.nationwide.text"),
    },
  ];

  const transportierenBox = [
    {
      title: t("mobeltransport.hero.box1.title")
    },
    {
      title: t("mobeltransport.hero.box2.title")
    },
    {
      title: t("mobeltransport.hero.box3.title")
    },
    {
      title: t("mobeltransport.hero.box4.title")
    },
    {
      title: t("mobeltransport.hero.box5.title")
    },
    {
      title: t("mobeltransport.hero.box6.title")
    },
  ];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);


  const handleSelect = () => {
    setTimeout(() => {
      navigate(`/transport?type=furniture`);
    }, 150);
  };

  /* ─────────────────────────── render ─────────────────────────── */
  return (
    <>
      <SEO
        title={t("mobelTransport.seo.title", "TransCirox – MobelTransport leicht gemacht")}
        description={t(
          "mobelTransport.seo.description",
          "Erhalten Sie kostenlos mehrere MobelTransportangebote von geprüften MobelTransportsfirmen in Ihrer Nähe."
        )}
      />

      {/* ── Original HeroSection (Navbar etc.) ── */}
      {showNavbar && <UmzugNavbarMenu />}

      {/* ════════════════════════════════════════
          HERO – "mobelTransport leicht gemacht"
      ════════════════════════════════════════ */}
      <section
        className="umzug-hero"
        style={{
          backgroundImage: `linear-gradient(to right, rgb(27 27 27 / 97%) 45%, rgb(51 51 51 / 55%) 70%, transparent 100%), url(${IMG_HERO_BG})`,
        }}
        aria-label="Hero"
      >
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <div className="hero-content" data-aos="fade-right">
            <h6 className="hero-subtitle2">{t("mobeltransport.hero.subtitle2", "Möbeltransport")}</h6>

            <h1>
              {t("mobeltransport.hero.title", "Möbeltransport")}
              <span>{t("mobeltransport.hero.tagline", "Vergleichen. Sparen. MobelTransportieren.")}</span>
            </h1>

            <p className="hero-subtitle">
              {t(
                "mobeltransport.hero.subtitle",
                "Erhalten Sie kostenlos mehrere MobelTransportangebote von geprüften MobelTransportsfirmen in Ihrer Nähe. Schnell, einfach und unverbindlich."
              )}
            </p>

            {/* ── Trust badges ── */}
            <div className="trust-badges">
              {trustBadges.map(({ icon, label1, label2 }, i) => (
                <div className="trust-badge" key={i}>
                  <div className="badge-icon" aria-hidden="true">
                    {icon}
                  </div>
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: label1 }} />
                    <div>{label2}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* ── CTA button ── */}
            <a onClick={() => handleSelect()} className="btn-orange">
              {t("mobeltransport.hero.cta", "Jetzt MobelTransportangebot erhalten")} →
            </a>

            <p className="hero-data-note">
              <AiOutlineSafety /> {" "}
              {t(
                "mobeltransport.hero.dataNote",
                "Ihre Daten sind bei uns sicher und werden nicht weitergegeben."
              )}
            </p>

          </div>

          {/* ── "Wir transportieren" Box ── */}
          <div className="hero-transport-box" data-aos="fade-up" data-aos-delay="200">
            <h6>{t("mobeltransport.hero.box.title", "Wir transportieren")}:</h6>
            <ul>
              {transportierenBox.map(({title}, i) => (
                <li key={i}>
                  <span className="check-icon">✓</span> {title}
                </li>
              ))}
            </ul>
          </div>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          WHY TRANSCIROX
      ════════════════════════════════════════ */}
      <section className="why-section">
        <Container>
          <h2 className="section-title mb-5" data-aos="fade-up">
            {t("mobeltransport.why.title", "Warum TransCirox?")}
          </h2>
          {/* <p className="section-subtitle" data-aos="fade-up" data-aos-delay="50">
            {t("mobeltransport.why.subtitle", "Ihre Vorteile auf einen Blick")}
          </p> */}

          <Row className="g-4 justify-content-center">
            {whyCards.map(({ icon, title, text }, i) => (
              <Col xs={12} sm={6} lg={3} key={i} data-aos="fade-up" data-aos-delay={i * 80}>
                <div className="why-card">
                  <div className="icon-wrap" aria-hidden="true">
                    {icon}
                  </div>
                  <h5>{title}</h5>
                  <p>{text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          HOW IT WORKS
      ════════════════════════════════════════ */}
      <section className="how-section">
        <Container>
          <h2 className="section-title" data-aos="fade-up">
            {t("mobeltransport.how.title", "So einfach funktioniert's")}
          </h2>

          <div className="steps-container" data-aos="fade-up" data-aos-delay="100">
            <div className="steps-row">
              {howSteps.map(({ num, icon, title, text }, i, arr) => (
                <div className="step-item" key={i}>
                  <div className="step-circle">
                    <span className="step-number">{num}</span>
                    <div className="step-icon">{icon}</div>
                  </div>
                  {i < arr.length - 1 && (
                    <div className="step-connector" aria-hidden="true">
                      <div className="connector-line"></div>
                      {/* <div className="connector-arrow">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path
                            d="M6 0L6 9"
                            stroke="#ff6b00"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                          <path
                            d="M3 6L6 9L9 6"
                            stroke="#ff6b00"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div> */}
                    </div>
                  )}
                  <h6 className="step-title">{title}</h6>
                  <p className="step-text">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          SOLUTIONS – "Für jeden mobelTransport"
      ════════════════════════════════════════ */}
      <section
        className="umzug-hero"
        style={{
          margin: "0 120px",
          backgroundImage: `linear-gradient(to right, rgb(27 27 27 / 97%) 45%, rgb(51 51 51 / 55%) 70%, transparent 100%), url(${IMG_WHY_BG})`,
        }}
        aria-label="Hero"
      >
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <div className="solutions-content" data-aos="fade-right">
            <h2>
              {t("mobeltransport.solutions.title1", "Für jeden mobelTransport")}
              <br />
              {t("mobeltransport.solutions.title2", "die passende Lösung")}
            </h2>
            <p>
              {t(
                "mobeltransport.solutions.text",
                "Egal ob Privatumzug, Firmenumzug oder Seniorenumzug – wir bringen Sie ans Ziel."
              )}
            </p>
            <ul className="solutions-list">
              {[
                t("mobeltransport.solutions.list.1", "Privatumzug"),
                t("mobeltransport.solutions.list.2", "Firmenumzug"),
                t("mobeltransport.solutions.list.3", "Nah- und Fernumzug"),
                t("mobeltransport.solutions.list.4", "Seniorenumzug"),
                t("mobeltransport.solutions.list.5", "Ein- und Auspackservice"),
                t("mobeltransport.solutions.list.6", "Möbelmontage"),
              ].map((item, i) => (
                <li key={i} className="text-white">
                  <span className="check">✓</span> {item}
                </li>
              ))}
            </ul>

          </div>

          {/* ── Google Rating Box ── */}
          <div className="google-rating-box" data-aos="fade-up" data-aos-delay="200">
            <div className="google-rating-header">
              <span className="google-icon"><FcGoogle /></span>
              <span className="google-title">{t("mobeltransport.solutions.googleRating.title", "Google")}</span>
            </div>
            <div className="google-rating-stars">
              <span className="stars">
                {t("mobeltransport.solutions.googleRating.stars", "★★★★★")}
              </span>
              <span className="rating-number">
                {t("mobeltransport.solutions.googleRating.rating", "4.8 / 5")}
              </span>
            </div>
            <p className="google-reviews">
              {t("mobeltransport.solutions.googleRating.reviews", "Basierend auf 350+ Bewertungen")}
            </p>
          </div>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          BOTTOM TRUST BAR
      ════════════════════════════════════════ */}
      <section className="trust-bar">
        <Container>

          {/* ════════════════════════════════════════
               CTA DARK SECTION
           ════════════════════════════════════════ */}
          <section className="cta-section" id="angebot" data-aos="fade-up">
            <Container>
              <Row className="align-items-center gy-4">
                <Col xs="auto">
                  <div className="cta-icon-wrap" aria-hidden="true">
                    <FaCalculator />
                  </div>
                </Col>

                <Col className="cta-text">
                  <h3>
                    {t("mobeltransport.cta.title", "Bereit für Ihren mobelTransport?")}
                  </h3>
                  <p>
                    {t(
                      "mobeltransport.cta.text",
                      "Starten Sie jetzt Ihre Anfrage und erhalten Sie kostenlos mehrere mobelTransportangebote."
                    )}
                  </p>
                </Col>

                <Col xs={12} sm="auto" className="cta-action text-center">
                  <a onClick={() => handleSelect()} className="btn-orange">
                    {t("mobeltransport.cta.btn", "Jetzt Angebot erhalten")} →
                  </a>
                  <p className="time-note">
                    {t("mobeltransport.cta.timeNote", "Dauert nur 2 Minuten")}
                  </p>
                </Col>
              </Row>
            </Container>
          </section>

          <Row className="g-4 justify-content-center">
            {trustCards.map(({ icon, title, text }, i) => (
              <Col xs={6} md={3} key={i}>
                <div className="trust-bar-item">
                  <div className="tb-icon" aria-hidden="true">
                    {icon}
                  </div>
                  <div>
                    <h6>{title}</h6>
                    <p>{text}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>


      {/* ════════════════════════════════════════
          FAQ
      ════════════════════════════════════════ */}
      <div className="faq-umzug">
        <p className="fw-bold text-center">{t("umzug.FaqUmzug.hero_description")}</p>

        <Row>
          <Col className="d-flex justify-content-center p-3">
            <Button
              onClick={() => navigate("/faq-mobel")}
              className="btn btn-orange p-3"
            >
              {t("umzug.FaqUmzug.hero_title")}
            </Button>
          </Col>
        </Row>
      </div>

      <Footer />
    </>
  );
}